<template>
  <div id="reportList" class="common_contentBox">
    <div class="common_search">
      <el-row>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="label">{{ $t('newApp.BasicInfo.an') }}：</span>
          <div class="content">
            <el-input v-model="form.activityCode" :placeholder="$t('general.pec')"
              @input="inputBoxFilter($event, 'activityCode')" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="label">{{ $t('newApp.activityInfo.noa') }}：</span>
          <div class="content">
            <el-input v-model="form.activityName" :placeholder="$t('general.pec')"
              @input="inputBoxFilter($event, 'activityName')" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="label">{{ $t('newApp.activityInfo.toa') }}：</span>
          <div class="content">
            <el-select v-model="form.activityType" :placeholder="$t('general.ps')">
              <el-option v-for="item in activityTypeList" :key="item.fieldKey" :label="item.fieldValue"
                :value="item.fieldKey" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="label">{{ $t('newApp.BasicInfo.Applicant') }}：</span>
          <div class="content">
            <el-input v-model="form.applyUserNameOrId" :placeholder="$t('general.pec')"
              @input="inputBoxFilter($event, 'applyUserNameOrId')" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <span class="label">{{ $t('eventList.AppStatus') }}：</span>
          <div class="content">
            <el-select v-model="form.approvalStatus" clearable :placeholder="$t('general.ps')" @change="searchBtn">
              <el-option v-for="item in approvalStatusList" :key="item.fieldKey" :label="item.fieldValue"
                :value="item.fieldKey" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <span class="label">{{ $t('newApp.BasicInfo.cs') }}：</span>
          <div class="content">
            <el-input v-model="form.salerNameOrId" :placeholder="$t('general.pec')"
              @input="inputBoxFilter($event, 'salerNameOrId')" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <span class="label">{{ $t('eventList.AppDepa') }}：</span>
          <div class="content">
            <el-select v-model="form.applyUserDeptNameOrCode" filterable remote clearable reserve-keyword
              :placeholder="$t('general.peak')" :remote-method="getApplyDeptList" :loading="applyLoading">
              <el-option v-for="item in applyDeptList" :key="item.userId" :label="item.deptName"
                :value="item.deptCode" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <span class="label">{{ $t('newApp.Attribute.cad') }}：</span>
          <div class="content">
            <el-select v-model="form.expenseDeptNameOrCode" filterable remote clearable reserve-keyword
              :placeholder="$t('general.peak')" :remote-method="getCostDeptList" :loading="applyLoading">
              <el-option v-for="item in costDeptList" :key="item.userId" :label="item.deptName"
                :value="item.deptCode" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <div class="label">{{ $t('newApp.Attribute.toe') }}</div>
          <div class="content">
            <el-select v-model="form.expenseTypeCode" :placeholder="$t('general.ps')" clearable>
              <el-option v-for="item in expenseTypeList" :key="item.expenseTypeCode" :label="item.expenseTypeName"
                :value="item.expenseTypeCode" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-if="isBrandPromotion" v-show="searchOpenFlag">
          <div class="label">{{ $t('eventList.Ms') }}</div>
          <div class="content">
            <el-select v-model="form.materialConfigStat" :placeholder="$t('general.ps')" clearable>
              <el-option v-for="item in materialStatusList" :key="item.val" :label="item.label" :value="item.val" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <el-button plain @click="onreset">{{ $t('btn.Reset') }}</el-button>
          <el-button type="primary" @click="searchBtn">{{ $t('btn.Search') }}</el-button>
        </div>
      </el-row>
      <div class="advancedSearchBtn">
        <span :class="searchOpenFlag ? 'open' : ''" @click="searchOpenFlag = !searchOpenFlag">
          <span>{{ searchOpenFlag ? $t('btn.CollspseS') : $t('btn.AdvancedS') }}</span>
          <i class="iconfont icon-rili4-icon" />
        </span>
      </div>
    </div>
    <div class="common_btnBar">
      <el-button type="primary" @click="biJump">{{ $t('eventList.BIFind') }}</el-button>
    </div>
    <commonTable ref="reportListTable" />
    <!-- 审批流程 -->
    <approvalProcessDialog :is-report="true" :activity-code="currentActivityCode"
      :approval-dialog-visible="approvalDialogVisible" @dialogCloseHandle="approvalCloseHandle" />
    <!-- 召回修改 -->
    <quickProceDialog :title="quickProceTitle" :quick-proce-dialog-visible="quickProceDialogVisible"
      :activity-code="currentActivityCode" @dialogCloseHandle="quickProceCloseHandle" />
    <!-- 活动评估 -->
    <assessmentDialog :activity-code="currentActivityCode" :assessment-dialog-visible="assessmentDialogVisible"
      @dialogCloseHandle="assessmentDialogClose" @handlerSuccess="assessmentSuccess" />

    <activityLevelDialog ref="activityLevelDialog" :activity-code="currentActivityCode"
      :activityLevel-dialog-visible="activityLevelDialogVisible" @dialogCloseHandle="activityLevelDialogClose"
      @handlerSuccess="activityLevelSuccess" />

    <productPromotionLeadingDialog ref="productPromotionLeadingDialog" :activity-code="currentActivityCode"
      :productPromotionLeading-dialog-visible="productPromotionLeadingDialogVisible"
      @dialogCloseHandle="productPromotionLeadingDialogClose" @handlerSuccess="productPromotionLeadingSuccess" />
  </div>
</template>

<script>
import commonTable from '@/components/commonTable';
import { TableRow, TableColumns } from '@/utils/tableOptions.js';
import approvalProcessDialog from './component/activityQuery/approvalProcessDialog';
import quickProceDialog from './component/activityQuery/quickProceDialog';
import assessmentDialog from './component/reportList/assessmentDialog';
import activityLevelDialog from './component/reportList/activityLevelDialog';
import productPromotionLeadingDialog from './component/reportList/productPromotionLeadingDialog';
import { activityQuery } from './service';
import { newApplicationFormApi } from '../newApplicationForm/service';
import { arrayQuery } from '../../utils/utils';
export default {
  name: 'ReportList',
  components: {
    commonTable,
    approvalProcessDialog,
    quickProceDialog,
    activityLevelDialog,
    assessmentDialog,
    productPromotionLeadingDialog

  },
  data() {
    return {
      searchOpenFlag: false,
      approvalDialogVisible: false,
      assessmentDialogVisible: false,
      activityLevelDialogVisible: false,
      productPromotionLeadingDialogVisible: false,
      form: {
        activityStatus: 0
      },
      tempForm: {
        activityStatus: 0
      },
      activityTypeList: [],
      applyDeptList: [],
      costDeptList: [],
      tableData: [],
      expenseTypeList: [],
      sexList: [
        {
          val: 'Man',
          label: '男'
        },
        {
          val: 'Women',
          label: '女'
        }
      ],
      materialStatusList: [
        {
          label: this.$t('eventList.Configured'),
          val: '1'
        },
        {
          label: this.$t('eventList.NotCon'),
          val: '0'
        }
      ],
      currentActivityCode: '',
      // applyKey: 'all',
      // expenseKey: 'all',
      applyLoading: false,
      isBrandPromotion: false,
      quickProceDialogVisible: false,
      quickProceTitle: '',
      approvalStatusList: [],
      activityLevelList: [],
      lang: localStorage.getItem('lang') || 'zh-CN',
      canHaveImc: false
    };
  },
  methods: {
    assessmentSuccess() {
      this.assessmentDialogVisible = false;
      this.searchBtn();
    },
    activityLevelSuccess() {
      this.$refs.activityLevelDialog.openDailg(false)
      this.searchBtn();
    },

    productPromotionLeadingSuccess() {
      this.$refs.productPromotionLeadingDialog.openDailg(false)
      this.searchBtn();
    },

    assessmentHandler(row) {
      this.currentActivityCode = row.marketActivity.activityCode;
      this.assessmentDialogVisible = true;
    },
    activityLevelHandler(row) {
      this.currentActivityCode = row.marketActivity.activityCode;
      this.$refs.activityLevelDialog.openDailg(true, row.marketActivity.activityLevel)
    },

    productPromotionLeadingHandler(row) {
      this.currentActivityCode = row.marketActivity.activityCode;
      this.$refs.productPromotionLeadingDialog.openDailg(true, row.marketActivity.productPromotionLeading)
    },

    assessmentDialogClose() {
      this.assessmentDialogVisible = false;
    },
    activityLevelDialogClose() {
      this.$refs.activityLevelDialog.openDailg(false)

    },
    productPromotionLeadingDialogClose() {
      this.$refs.productPromotionLeadingDialog.openDailg(false)

    },

    biJump() {
      window.open('http://ruijiebi.ruijie.com.cn/webroot/decision?rjl=oa');
    },
    quickProcessingBtn(row, title) {
      this.quickProceTitle = title;
      this.currentActivityCode = row.marketActivity.activityCode;
      this.quickProceDialogVisible = true;
    },
    quickProceCloseHandle() {
      this.quickProceDialogVisible = false;
    },
    inputBoxFilter(val, key) {
      let numVal = val.replace(/^\s+|\s+$/g, '');
      this.$set(this.form, key, numVal);
    },
    // 搜索申请部门的选中事件
    applyChange() {

    },
    approvalStateBtn(row) {
      if (row.approveStatus === this.$t('home.pf')) {
        this.$router.push({
          path: '/activityDetails',
          query: {
            activityCode: row.marketActivity.activityCode,
            metaActive: '/activityQuery',
            activeName: 'ExecutionFeedback'
          }
        });
        return;
      }
      this.currentActivityCode = row.marketActivity.activityCode;
      this.approvalDialogVisible = true;
    },
    approvalCloseHandle() {
      this.approvalDialogVisible = false;
    },
    onreset() {
      this.form = {
        activityStatus: 0
      };
      this.searchBtn();
    },
    searchBtn() {
      this.tempForm = JSON.parse(JSON.stringify(this.form));
      this.$refs.reportListTable.pageData.pageNum = 1;
      this.$refs.reportListTable.getTableData({ url: '/activity/market_activity_list', params: this.tempForm });
    },
    detailsJump(row) {
      let { userId } = this.$store.state.userInfo.sysUser;
      if (row.approveStatusCode === 101 && row.marketActivity.applyUserId === userId) {
        this.$router.push({
          path: '/transferApplication',
          query: {
            activityCode: row.marketActivity.activityCode,
            metaActive: '/reportList'
          }
        });
      } else {
        this.$router.push({
          path: '/reportDetails',
          query: {
            activityCode: row.marketActivity.activityCode,
            metaActive: '/reportList'
          }
        });
      }
    },
    loadTable() {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._width('160')
          ._title(this.$t('eventList.ActCode'))
          ._fixed('left')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <span class="btnText" onClick={() => { this.detailsJump(row); }}>{row.marketActivity.activityCode}</span>
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('20%')
          ._title(this.$t('newApp.activityInfo.noa'))
          ._data('marketActivity.activityName')
      );
      tableRow.push(
        new TableColumns()
          ._width('12%')
          ._title(this.$t('newApp.activityInfo.toa'))
          ._data('marketActivity.activityType')
      );
      tableRow.push(
        new TableColumns()
          ._width('8%')
          ._title(this.$t('newApp.BasicInfo.Applicant'))
          ._data('marketActivity.applyUserName')
      );
      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('newApp.BasicInfo.cs'))
          ._data('marketActivity.salerName')
      );
      tableRow.push(
        new TableColumns()
          ._width('8%')
          ._title(this.$t('eventList.Department'))
          ._data('marketActivity.salerDeptName')
      );
      tableRow.push(
        new TableColumns()
          ._width('8%')
          ._title(this.$t('newApp.activityInfo.ps'))
          ._data('brandPromotionSupport')
      );
      tableRow.push(
        new TableColumns()
          ._width('8%')
          ._title(this.$t('newApp.BasicInfo.at'))
          ._data('marketActivity.applyTime')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let date = new Date(row.marketActivity.applyTime.replace(/-/g, '/')).format('yyyy-MM-dd');
              return (
                <span>{date}</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('eventList.Me'))
          ._data('marketActivity.totalCost')
          ._align('right')
      );
      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('eventList.QC'))
          ._data('approveName')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let approveName = '';
              if (row.approvers) {
                approveName = row.approvers.map(item => {
                  return item.userName;
                }).join(',');
              }
              return (
                <div>
                  <span>{approveName}</span>
                </div>
              );
            }
          })
      );
      if (this.isBrandPromotion) {
        tableRow.push(
          new TableColumns()
            ._width('10%')
            ._title(this.$t('eventList.Ms'))
            ._cellType('customDom')
            ._cellData({
              formater: ({ row, column }) => {
                let text = row.marketActivity.materialConfigStat ? this.$t('eventList.Configured') : this.$t('eventList.NotCon');
                return (
                  <div>{text}</div>
                );
              }
            })
        );
      }
      if (this.lang === 'zh-CN') {
        tableRow.push(
          new TableColumns()
            ._width('10%')
            ._title(this.$t('newApp.activityInfo.csl'))
            ._cellType('customDom')
            ._data('marketActivity.activityLevel')
            ._cellData({
              formater: ({ row, column }) => {
                let text = row.activityLevel;
                if (this.lang === 'zh-CN') {
                  if (row.marketActivity.activityLevel) {
                    text = arrayQuery(row.marketActivity.activityLevel, this.activityLevelList, 'fieldKey').fieldValue;
                    if (text === undefined) {
                      text = '-';
                    }
                  } else {
                    text = '-';
                  }
                }
                return (
                  this.lang === 'zh-CN' ?
                    <div>
                      {this.canHaveImc ? (<el-button type="text" onClick={() => { this.activityLevelHandler(row); }}>{{ text }}</el-button>) : { text }}
                    </div> : <div>-</div>
                );
              }
            })
        );
        tableRow.push(
          new TableColumns()
            ._width('10%')
            ._title(this.$t('newApp.BasicInfo.ppl'))
            ._cellType('customDom')
            ._data('marketActivity.productPromotionLeading')
            ._cellData({
              formater: ({ row, column }) => {
                let text = row.marketActivity.productPromotionLeading;
                if (text === null) {
                  text = '否'
                }
                return (
                  <div>
                    <el-button type="text" onClick={() => { this.productPromotionLeadingHandler(row); }}>{{ text }}</el-button>
                  </div>

                );
              }
            })
        );
      }

      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('eventList.Doi'))
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>{row.importance ? row.importance : this.$t('eventList.NotEva')}</div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('8%')
          ._title(this.$t('eventList.Feasibility'))
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>{row.enforceability ? row.enforceability : this.$t('eventList.NotEva')}</div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('eventList.Sos'))
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>{row.supportStrength ? row.supportStrength : this.$t('eventList.NotEva')}</div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('eventList.AppStatus'))
          ._fixed('right')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let text = row.approveStatus;
              if (this.form.approvalStatus) {
                text = arrayQuery(this.form.approvalStatus, this.approvalStatusList, 'fieldKey').fieldValue;
              }
              return (
                <div>
                  <el-button type="text" onClick={() => { this.approvalStateBtn(row); }}>{text}</el-button>
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('210')
          ._title(this.$t('general.Operation'))
          ._fixed('right')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let userInfo = this.$store.state.userInfo;
              // 召回修改：当费用归属只有一条的时候才可以召回    召回后该活动会保存在草稿里
              // 活动评估：当前登陆人为品牌推广部的才可以进行活动评价
              return (
                <div>
                  <el-button type="text" onClick={() => { this.quickProcessingBtn(row, this.$t('btn.Revoke')); }}>{this.$t('btn.Revoke')}</el-button>
                  <el-button type="text" onClick={() => { this.quickProcessingBtn(row, this.$t('btn.RecallC')); }}>{this.$t('btn.RecallC')}</el-button>
                  {
                    userInfo.sysUser.deptCode.indexOf('000013') === 0 ? (
                      <el-button type="text" onClick={() => { this.assessmentHandler(row); }}>{this.$t('btn.ActivityE')}</el-button>
                    ) : null
                  }
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.reportListTable.setColumn(column, {
        resizable: true
      });
      this.$refs.reportListTable.loadTable({ url: '/activity/market_activity_list', listKey: 'searchMiddleDTOs', params: { activityStatus: 0 } });
    },
    getActivityType() {
      let params = [
        'activity_type'
      ];
      newApplicationFormApi.getActivityList(params).then(res => {
        if (res.status === '200') {
          this.activityTypeList = res.data.activity_type;
        }
      });
    },
    getApplyDeptList(applyKey) {
      if (applyKey && applyKey.indexOf(' ') === 0) {
        this.applyDeptList = [];
        return;
      }
      applyKey = applyKey || 'all';
      let params = {
        type: 'APPLAY',
        key: applyKey
      };
      activityQuery.getDeptList(params).then(res => {
        if (res.status === '200') {
          this.applyDeptList = res.data;
        }
      });
    },
    getCostDeptList(expenseKey) {
      if (expenseKey && expenseKey.indexOf(' ') === 0) {
        this.costDeptList = [];
        return;
      }
      expenseKey = expenseKey || 'all';
      let params = {
        type: 'EXPENSE',
        key: expenseKey
      };
      activityQuery.getDeptList(params).then(res => {
        if (res.status === '200') {
          this.costDeptList = res.data;
        }
      });
    },
    getExpenseTypeList() {
      activityQuery.getExpenseTypeList().then(res => {
        if (res.status === '200') {
          this.expenseTypeList = res.data;
        }
      });
    },
    getExamineStatusList() {
      let params = [
        'report_approval_status'
      ];
      newApplicationFormApi.getActivityList(params).then(res => {
        if (res.status === '200') {
          this.approvalStatusList = res.data.report_approval_status;
        }
      });
    },
    getActivityLevelList() {
      let params = [
        'activity_level'
      ];
      newApplicationFormApi.getActivityList(params).then(res => {
        if (res.status === '200') {
          this.activityLevelList = res.data.activity_level;
        }
      });
    }
  },
  activated() {
    this.$refs.reportListTable.getTableData({ url: '/activity/market_activity_list', params: this.tempForm });
  },
  mounted() {
    newApplicationFormApi.checkUserIsImc().then(res => {
      console.log(res)
      this.canHaveImc = res.data
    })
    this.isBrandPromotion = this.$store.state.userInfo.belongToBrandPromotionDept;
    this.loadTable();
    this.getActivityType();
    this.getApplyDeptList();
    this.getCostDeptList();
    this.getExpenseTypeList();
    this.getExamineStatusList();
    this.getActivityLevelList();
  }
};
</script>

<style scoped></style>
